import { Box, Stack, styled, Typography } from '@mui/material';

export const DialogHeader = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  minHeight: 56,
  background: '#000000',
  color: '#FFFFFF',
  padding: '11px 20px',
  fontFamily: 'inherit',
  fontSize: 18,
  fontWeight: 700,
  lineHeight: '24px',
  '& .MuiIconButton-root': {
    color: '#FFFFFF',
    width: 32,
    height: 32,
    '&:hover': { background: 'rgba(255,255,255,0.08)' },
  },
});

export const DialogBody = styled(Box)({
  padding: '24px 32px 16px',
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
  background: '#FFFFFF',
});

export const Section = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
});

export const SectionTitle = styled(Typography)({
  fontSize: 12,
  fontWeight: 700,
  lineHeight: '20px',
  letterSpacing: 0,
  color: '#929495',
  textTransform: 'uppercase',
});

export const SectionDescription = styled(Typography)({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '22px',
  color: '#000000',
});

export const DialogFooter = styled(Stack)({
  flexDirection: 'row',
  justifyContent: 'flex-end',
  gap: 8,
  padding: 16,
  background: '#FFFFFF',
});
